import script from "./VideoListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoListView.vue?vue&type=script&lang=ts&setup=true"

import "./VideoListView.vue?vue&type=style&index=0&id=64c13eda&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c13eda"]])

export default __exports__